import { Lightning } from '@lightningjs/sdk';

export const UNLOADED_TEXTURE_ALPHA = 0.00001;

/**
 * Generates Lightning image texture descriptor object
 *
 * @param {string} src image asset URL
 * @param {number} w with of a generated texture, in pixels
 * @param {number} h height of a generated texture, in pixels
 * @param {('cover'|'contain')} resizeMode
 * @returns {object}
 */
export const makeTextureDescriptor = (src, w, h, resizeMode) => ({
  type: Lightning.textures.ImageTexture,
  src,
  resizeMode: { type: resizeMode, w, h },
});

/**
 * Generates Lightning image texture that fills a specified area preserving image aspect ratio
 *
 * @param {*} src image asset URL
 * @param {number} w with of a generated texture, in pixels
 * @param {number} h height of a generated texture, in pixels
 * @returns {object}
 */
export const cover = (src, w, h) => makeTextureDescriptor(src, w, h, 'cover');

/**
 * Generates Lightning image texture that will be fit into a specified area preserving image aspect ratio
 *
 * @param {*} src image asset URL
 * @param {number} w with of a generated texture, in pixels
 * @param {number} h height of a generated texture, in pixels
 * @returns {object}
 */
export const contain = (src, w, h) => makeTextureDescriptor(src, w, h, 'contain');
